import dayjs from 'dayjs';
import Cookies from 'js-cookie';
export const getEventCookieName = (name) => `zl_com_mes_${name.toLowerCase()}`;
export const setEventCookie = (voucherCode, endDate, reusableCode) => {
    const cookieName = getEventCookieName(voucherCode);
    let expires = new Date(endDate);
    if (reusableCode) {
        const endOfDay = dayjs().endOf('day').toDate();
        expires = endOfDay > expires ? expires : endOfDay;
    }
    Cookies.set(cookieName, 'true', { expires });
    return expires;
};
//# sourceMappingURL=utils.js.map